/* Earth Energy content pages — FAQ accordion (null-safe, scoped to .ee-page). */
(function(){
  var pages=document.querySelectorAll('.ee-page');
  if(!pages.length) return;
  pages.forEach(function(root){
    root.querySelectorAll('.faq-q').forEach(function(btn){
      btn.addEventListener('click',function(){
        var item=btn.closest('.faq-item');
        var ans=item.querySelector('.faq-a');
        var isOpen=item.classList.contains('open');
        if(isOpen){ ans.style.maxHeight=null; item.classList.remove('open'); }
        else{ item.classList.add('open'); ans.style.maxHeight=ans.scrollHeight+'px'; }
      });
    });
  });
})();
